"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../Text"));

var _NakedButton = _interopRequireDefault(require("../NakedButton"));

var _styledSystem = require("styled-system");

var _get = _interopRequireDefault(require("lodash/get"));

var _polished = require("polished");

var _excluded = ["totalImages", "variant", "onClick", "textStyles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mediaCounterStyle = (0, _styledSystem.variant)({
  key: 'mediaCounter'
});

var getBackgroundWithOpacity = function getBackgroundWithOpacity(props) {
  var _mediaCounterStyle = mediaCounterStyle(props),
      backgroundColor = _mediaCounterStyle.backgroundColor,
      opacity = _mediaCounterStyle.opacity;

  return (0, _polished.rgba)(backgroundColor, opacity);
};

var MediaCounterWrapper = ( /*#__PURE__*/0, _styledBase["default"])(_NakedButton["default"], {
  target: "e1u0tw2x0",
  label: "MediaCounterWrapper"
})("letter-spacing:", function (props) {
  return (0, _get["default"])(mediaCounterStyle(props), 'letterSpacing');
}, ";color:", function (props) {
  return (0, _get["default"])(mediaCounterStyle(props), 'color');
}, ";background-color:", function (props) {
  return getBackgroundWithOpacity(props);
}, ";text-transform:", function (props) {
  return (0, _get["default"])(mediaCounterStyle(props), 'textTransform');
}, ";border-radius:", (0, _styledSystem.themeGet)('radii.default'), ";&:hover{background-color:", function (props) {
  return (0, _get["default"])(mediaCounterStyle(props), 'backgroundColor');
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhQ291bnRlckJ1dHRvbi9NZWRpYUNvdW50ZXJCdXR0b24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0IrQyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9NZWRpYUNvdW50ZXJCdXR0b24vTWVkaWFDb3VudGVyQnV0dG9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgVGV4dCBmcm9tICcuLi9UZXh0JztcbmltcG9ydCBOYWtlZEJ1dHRvbiBmcm9tICcuLi9OYWtlZEJ1dHRvbic7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB0aGVtZUdldCwgdmFyaWFudCB9IGZyb20gJ3N0eWxlZC1zeXN0ZW0nO1xuaW1wb3J0IGdldCBmcm9tICdsb2Rhc2gvZ2V0JztcbmltcG9ydCB7IHJnYmEgfSBmcm9tICdwb2xpc2hlZCc7XG5cbmNvbnN0IG1lZGlhQ291bnRlclN0eWxlID0gdmFyaWFudCh7IGtleTogJ21lZGlhQ291bnRlcicgfSk7XG5cbmNvbnN0IGdldEJhY2tncm91bmRXaXRoT3BhY2l0eSA9IChwcm9wcykgPT4ge1xuICBjb25zdCB7IGJhY2tncm91bmRDb2xvciwgb3BhY2l0eSB9ID0gbWVkaWFDb3VudGVyU3R5bGUocHJvcHMpO1xuICByZXR1cm4gcmdiYShiYWNrZ3JvdW5kQ29sb3IsIG9wYWNpdHkpO1xufTtcblxuY29uc3QgTWVkaWFDb3VudGVyV3JhcHBlciA9IHN0eWxlZChOYWtlZEJ1dHRvbilgXG4gIGxldHRlci1zcGFjaW5nOiAkeyhwcm9wcykgPT4gZ2V0KG1lZGlhQ291bnRlclN0eWxlKHByb3BzKSwgJ2xldHRlclNwYWNpbmcnKX07XG4gIGNvbG9yOiAkeyhwcm9wcykgPT4gZ2V0KG1lZGlhQ291bnRlclN0eWxlKHByb3BzKSwgJ2NvbG9yJyl9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyhwcm9wcykgPT4gZ2V0QmFja2dyb3VuZFdpdGhPcGFjaXR5KHByb3BzKX07XG4gIHRleHQtdHJhbnNmb3JtOiAkeyhwcm9wcykgPT4gZ2V0KG1lZGlhQ291bnRlclN0eWxlKHByb3BzKSwgJ3RleHRUcmFuc2Zvcm0nKX07XG4gIGJvcmRlci1yYWRpdXM6ICR7dGhlbWVHZXQoJ3JhZGlpLmRlZmF1bHQnKX07XG5cbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHsocHJvcHMpID0+XG4gICAgICBnZXQobWVkaWFDb3VudGVyU3R5bGUocHJvcHMpLCAnYmFja2dyb3VuZENvbG9yJyl9O1xuICB9XG5gO1xuXG5jb25zdCBNZWRpYUNvdW50ZXJCdXR0b24gPSAoe1xuICB0b3RhbEltYWdlcyxcbiAgdmFyaWFudCA9ICdkYXJrJyxcbiAgb25DbGljayA9ICgpID0+IHt9LFxuICB0ZXh0U3R5bGVzID0ge30sXG4gIC4uLnJlc3Rcbn0pID0+IHtcbiAgaWYgKCF0b3RhbEltYWdlcykgcmV0dXJuIG51bGw7XG5cbiAgcmV0dXJuIChcbiAgICA8TWVkaWFDb3VudGVyV3JhcHBlclxuICAgICAgb25DbGljaz17b25DbGlja31cbiAgICAgIHZhcmlhbnQ9e3ZhcmlhbnR9XG4gICAgICBweD17M31cbiAgICAgIHB5PXsxfVxuICAgICAgey4uLnJlc3R9XG4gICAgPlxuICAgICAgPFRleHQgZm9udFNpemU9XCJzbVwiIHsuLi50ZXh0U3R5bGVzfT5cbiAgICAgICAgVmlldyB7dG90YWxJbWFnZXMgPiAxID8gYCR7dG90YWxJbWFnZXN9IGAgOiAnJ31waG90b1xuICAgICAgICB7dG90YWxJbWFnZXMgPiAxID8gJ3MnIDogJyd9XG4gICAgICA8L1RleHQ+XG4gICAgPC9NZWRpYUNvdW50ZXJXcmFwcGVyPlxuICApO1xufTtcblxuTWVkaWFDb3VudGVyQnV0dG9uLnByb3BUeXBlcyA9IHtcbiAgLi4udmFyaWFudC5wcm9wVHlwZXMsXG4gIHRleHRTdHlsZXM6IFByb3BUeXBlcy5vYmplY3QsXG4gIHRvdGFsSW1hZ2VzOiBQcm9wVHlwZXMubnVtYmVyLFxuICBvbkNsaWNrOiBQcm9wVHlwZXMuZnVuYyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IE1lZGlhQ291bnRlckJ1dHRvbjtcbiJdfQ== */"));

var MediaCounterButton = function MediaCounterButton(_ref) {
  var totalImages = _ref.totalImages,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'dark' : _ref$variant,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$textStyles = _ref.textStyles,
      textStyles = _ref$textStyles === void 0 ? {} : _ref$textStyles,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!totalImages) return null;
  return /*#__PURE__*/_react["default"].createElement(MediaCounterWrapper, (0, _extends2["default"])({
    onClick: onClick,
    variant: variant,
    px: 3,
    py: 1
  }, rest), /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    fontSize: "sm"
  }, textStyles), "View ", totalImages > 1 ? "".concat(totalImages, " ") : '', "photo", totalImages > 1 ? 's' : ''));
};

MediaCounterButton.propTypes = _objectSpread(_objectSpread({}, _styledSystem.variant.propTypes), {}, {
  textStyles: _propTypes["default"].object,
  totalImages: _propTypes["default"].number,
  onClick: _propTypes["default"].func
});
var _default = MediaCounterButton;
exports["default"] = _default;